import React, { useState } from "react";
import { Link } from "react-router-dom";

import MapSvg from "./MapSvg";
import rubriques from "../../datas/rubriques.json";
const NavZones = rubriques.filter(item=> item.slug === 'navzones');

export default function Map() {
    const [ linkHover, setLinkHover ] = useState(null);
    const handleLinkHover = (e) => {
        setLinkHover(e);
    }

    return (
        <>
            <h2>Notre bilan<br/>par territoire d'intervention</h2>
            <div id="map__links">
                <ul>
                {
                    NavZones.map((item) => {
                        return item.items && item.items.filter(it => it.mapMenu !== false).map(_item =>
                            <li className={`${_item.slug} ${ linkHover && linkHover === _item.slug ? 'active': ''}`} onMouseEnter={ e => handleLinkHover(_item.slug) }>
                                <Link to={_item.link}>{_item.content}</Link>
                            </li>
                        );
                    })
                }
                </ul>
            </div>
            <MapSvg handleLinkHover={ handleLinkHover } linkHover={ linkHover } />
        </>
    );
}
